export const testimonials = [
  {
    id: 't-001',
    name: '林小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-01&orientation=squarish',
    role: '失眠困扰者 → 深度睡眠达人',
    content: '以前每晚都要在床上辗转反侧一两个小时才能睡着。朋友推荐了asmrone之后，现在每天睡前听一段耳语或雨声，基本十分钟之内就能睡着。睡眠质量明显提升了，白天精神也好多了！',
    rating: 5,
    date: '2026-07-30',
  },
  {
    id: 't-002',
    name: '张明远',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20gentle%20expression%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-02&orientation=squarish',
    role: '程序员 · 焦虑缓解者',
    content: '做开发的压力真的很大，经常加班到深夜，脑子里全是代码。asmrone的角色扮演音频真的太棒了，尤其是理发店和SPA那两期，听完感觉整个人都被治愈了，焦虑感明显降低。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 't-003',
    name: '陈思怡',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20woman%20with%20calm%20smile%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-03&orientation=squarish',
    role: '考研学生 · 专注力提升者',
    content: '备考期间注意力很难集中，试过很多方法都不太管用。后来发现在图书馆白噪音和键盘打字声的陪伴下学习效率特别高！现在每天学习的时候都会打开asmrone，已经成为考研必备了。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 't-004',
    name: '王浩然',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20with%20relaxed%20expression%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-04&orientation=squarish',
    role: 'ASMR资深爱好者',
    content: '从2019年就开始听ASMR了，国内外的平台都用过。asmrone的内容质量真的很高，录音设备专业，触发音层次丰富。特别喜欢那个木块敲击系列，不同木材的声音质感区分得很细腻。强烈推荐！',
    rating: 5,
    date: '2026-07-22',
  },
  {
    id: 't-005',
    name: '赵雅雯',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20woman%20with%20gentle%20warm%20smile%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-05&orientation=squarish',
    role: '新手妈妈 · 产后放松',
    content: '生完宝宝后一直很焦虑，睡眠质量直线下降。老公给我推荐了asmrone，一开始还不太相信声音能帮助放松，但试了一次雨夜的音频之后真的惊了——那种被包裹的安全感太治愈了。现在每天宝宝睡着后，这就是属于我的放松时间。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 't-006',
    name: '刘子豪',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20with%20friendly%20smile%2C%20minimalist%20cream%20background%2C%20soft%20studio%20lighting%2C%20natural%20portrait%20photography&width=200&height=200&seq=avatar-06&orientation=squarish',
    role: '自由职业者 · 创意工作者',
    content: '做设计的时候需要大量灵感，asmrone的自然音效系列就是我的创意源泉。在海浪声或森林鸟鸣中工作，感觉思路特别清晰。已经推荐给好几个同事了，大家都说好用！',
    rating: 4,
    date: '2026-07-18',
  },
];

export const brandStats = [
  { label: '累计用户', value: '500,000+', icon: 'ri-user-heart-line' },
  { label: '音频内容', value: '2,000+', icon: 'ri-music-line' },
  { label: '日均收听', value: '180分钟', icon: 'ri-timer-line' },
  { label: '好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
];